import Box from "@mui/material/Box";
import {useMemo} from "react";

import {designColors} from "~/ui";

import {PageLayoutColorVariant} from "../types";

export interface BmDefaultPageLayoutProps {
  colorVariant?: PageLayoutColorVariant;
  children: React.ReactNode;
}

export const BmDefaultPageLayout: React.FC<BmDefaultPageLayoutProps> = ({colorVariant = "grey", children}) => {
  const bgColor = useMemo(() => {
    switch (colorVariant) {
      case "grey":
        return designColors.grey_6;
      case "offWhite":
        return designColors.off_white;
      default:
        return designColors.grey_6;
    }
  }, [colorVariant]);

  return (
    <Box minHeight="100vh" bgcolor={bgColor}>
      {children}
    </Box>
  );
};
